'use strict';

import React from 'react';

export default function IconFavorite (props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M15.7858 7.28573C15.7858 4.29268 14.046 2.42859 11.3334 2.42859C10.0967 2.42859 9.13985 2.8523 8.50007 3.68799C7.86029 2.8523 6.90345 2.42859 5.66674 2.42859C2.95417 2.42859 1.21436 4.29268 1.21436 7.28573C1.21436 9.62846 3.58495 12.2779 8.28018 15.316C8.41399 15.4026 8.58615 15.4026 8.71996 15.316C13.4152 12.2779 15.7858 9.62846 15.7858 7.28573ZM11.3334 3.23813C13.5859 3.23813 14.9762 4.72778 14.9762 7.28574C14.9762 9.2279 12.8321 11.6564 8.50002 14.4933C4.16799 11.6564 2.02383 9.2279 2.02383 7.28574C2.02383 4.72778 3.41417 3.23813 5.66669 3.23813C6.86766 3.23813 7.66942 3.69628 8.13799 4.63343C8.28716 4.93176 8.71289 4.93176 8.86206 4.63343C9.33063 3.69628 10.1324 3.23813 11.3334 3.23813Z" fill="#757575"/>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/ui/Icons/IconFavorite.jsx